import React from 'react'
import  { BrowserRouter as Router
        , Switch
        , Route
        } from 'react-router-dom'
import Home from './components/pages/Home'
import Company from './components/pages/Company'
import Services from './components/pages/Services'
import './index.css'

class App extends React.Component {
  // nb the last route is the noMatch route, which matches any other path
  render() {
    return (
      <Router>
        <Switch>
          <Route path='/' exact component={Home}  />
          <Route path="/company" exact component={Company}/>
          <Route path="/services" exact component={Services}/>
          <Route component={Home} />
        </Switch>
      </Router>
    )
  }

}

export default App



// WEBPACK FOOTER //
// ./src/App.js